// Copyright 2025, University of Maryland, All Rights Reserved
import React, { createContext } from 'react';

interface AppConfig {
  app_id: string;
  debug?: boolean;
}

export const AppConfigContext = createContext<AppConfig | undefined>(undefined);

export const AppConfigProvider: React.FC<{
  children: React.ReactNode;
  app_id: string;
  debug?: boolean;
}> = ({ children, app_id, debug = false }) => {
  return (
    <AppConfigContext.Provider value={{ app_id, debug }}>
      {children}
    </AppConfigContext.Provider>
  );
};